import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './NoImage.css';

export const NoImage = (props: { text?: string }) => {
  const { text = 'Нет фото' } = props;

  return (
    <div className={styles['image']}>
      <div className={styles['image-icon']}>
        <IconPlaceholderImages24 display="block" color="white_60" />
      </div>
      <UIText1 fontWeight={'bold'} color={'text-secondary-default'}>
        {text}
      </UIText1>
    </div>
  );
};
